import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=1149b728"
import script from "./DonutChart.vue?vue&type=script&lang=js"
export * from "./DonutChart.vue?vue&type=script&lang=js"
import style0 from "./DonutChart.vue?vue&type=style&index=0&id=1149b728&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports